<template>
  <div class="container">
    <h3>项目组配置</h3>
    <el-form inline @submit.native.prevent="search(1)">
      <el-form-item label="项目组名称"><el-input v-model="name" clearable /></el-form-item>
      <el-form-item><el-button :loading="loading" @click="search(1)">查询</el-button><el-button type="primary" @click="edit()">新增项目组</el-button></el-form-item>
    </el-form>
    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
    <el-table :data="rows" v-loading="loading" border>
      <el-table-column prop="name" label="项目组名称" />
      <el-table-column prop="code" label="项目组编码" />
      <el-table-column prop="updated_by" label="更新人" />
      <el-table-column prop="update_date" label="更新时间" :formatter="formatProductionDateTime" />
      <el-table-column label="操作" min-width="180"><template slot-scope="scope"><el-button type="primary" @click="edit(scope.row)" size="mini">编辑</el-button><el-button type="danger" @click="remove(scope.row)" size="mini">删除</el-button></template></el-table-column>
    </el-table>
    <el-pagination :current-page.sync="page" :page-size="10" :total="total" layout="total, prev, pager, next" @current-change="search" />
    <el-dialog :title="form.id ? '编辑项目组' : '新增项目组'" :visible.sync="dialog" :close-on-click-modal="false" width="min(560px, 95%)">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="项目组名称" prop="name"><el-input v-model.trim="form.name" maxlength="64" show-word-limit /></el-form-item>
        <el-form-item label="项目组编码"><el-input v-model.trim="form.code" :disabled="!!form.id" maxlength="32" placeholder="留空自动生成 UUID，也可手动输入" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="saving" @click="dialog = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { production_list, production_create, production_update, production_delete } from '@/api/getData';
import { productionError, formatProductionDateTime } from '@/utils/production';
export default {
  name: 'config_project_team',
  data: () => ({ name: '', rows: [], total: 0, page: 1, loading: false, saving: false, error: '', dialog: false, form: {}, rules: { name: [{ required: true, whitespace: true, message: '请输入项目组名称', trigger: 'blur' }] } }),
  created() { this.search(); },
  methods: {
    formatProductionDateTime,
    async search(page = this.page) {
      this.page = page; this.loading = true; this.error = '';
      try { const data = await production_list('project_team', { name: this.name, limit: 10, offset: (page - 1) * 10 }); this.rows = data.results; this.total = data.count; }
      catch (error) { this.error = productionError(error); }
      finally { this.loading = false; }
    },
    edit(row) { this.form = row ? { id: row.id, name: row.name, code: row.code } : { name: '', code: '' }; this.dialog = true; this.$nextTick(() => this.$refs.form.clearValidate()); },
    async save() {
      if (!await this.$refs.form.validate().catch(() => false)) return;
      this.saving = true;
      try { const data = { name: this.form.name }; if (this.form.id) await production_update('project_team', this.form.id, data); else await production_create('project_team', { ...data, code: this.form.code }); this.dialog = false; await this.search(); }
      catch (error) { this.$message.error(productionError(error)); }
      finally { this.saving = false; }
    },
    async remove(row) {
      try { await this.$confirm(`删除项目组“${row.name}”？`, '确认删除'); await production_delete('project_team', row.id); await this.search(); }
      catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(productionError(error)); }
    }
  }
};
</script>

<style scoped>
h3 { margin-bottom: 20px; }
.el-pagination { margin-top: 20px; text-align: right; }
.el-alert { margin-bottom: 12px; }
</style>
